import * as React from 'react';
import styles from './ShipConsumables.scss';
import classNames from 'classnames';
import { t } from '~/utils/localization';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { items } from '@wg/wows-entities/const';

interface IShipConsumables {
    shipId: number;
}

const ShipConsumables = ({ shipId }: IShipConsumables) => {
    return (
        <div className={classNames(styles.content, styles.borderBottom)}>
            <div className={styles.spoilerSubTitle}>{t('Доступное снаряжение: ')}</div>
            <div className={classNames(styles.contentBlockBody, styles.consumablesContent)}>
                <WoWSEntity
                    type={items.CONSUMABLES}
                    id={shipId}
                    presentation={{
                        withTooltip: true,
                        renderWithoutFade: true,
                    }}
                />
            </div>
        </div>
    );
};

export default ShipConsumables;
